import {
  FormHelperText as FormHelperTextMui,
  FormHelperTextProps as FormHelperTextPropsMui,
} from '@mui/material';

export type FormHelperTextProps = FormHelperTextPropsMui;

export function FormHelperText({ ...rest }: FormHelperTextProps) {
  return <FormHelperTextMui {...rest} />;
}
